export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-lg font-bold text-background-50">91视频网站</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/55">
              91视频网站提供海量电影、电视剧、综艺、动漫高清免费在线观看，每日更新，多线路切换播放流畅不卡顿，是您追剧观影的首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '主题索引', href: '#index' },
                { label: '平台特色', href: '#features' },
                { label: '精彩视频', href: '#media' },
                { label: '热门排行', href: '#ranking' },
                { label: '最新动态', href: '#updates' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-50/55 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {['动作大片', '喜剧专场', '悬疑推理', '科幻奇幻', '动漫番剧', '综艺娱乐'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="text-sm text-background-50/55 hover:text-primary-400 transition-colors"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/55 leading-relaxed">
              感谢所有合作伙伴对91视频网站的支持与信赖。合作事宜请联系我们。
            </p>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 91视频网站. 本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-background-50/40 hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-background-50/40 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-50/40 hover:text-primary-400 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}